import { LinkButton } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './Buttons.css';
import { ButtonsForAbcExpContainer } from './ButtonsForAbcExpContainer';
import { EButtonGroupType, getButtonGroupType } from './utils';
import { CallButton } from '../../components/CallButton';
import { PhoneNumber } from '../../components/PhoneNumber';
import { useIsDailyrentOnlineBookingEnabled } from '../../hooks/useIsDailyrentOnlineBookingEnabled';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectABCActionButtonExpGroup } from '../../selectors/experiments/selectABCActionButtonExpGroup';
import { ChatButton } from '../ChatButton';

interface IButtonProps {
  className?: string;
  narrow?: boolean;
  offer: IDailyRentOfferForMobileSite;
  offerLink: string;
  onMoreClick(): void;
  onBookClick(): void;
  onCallClick(): void;
  onChatClick(): void;
}

export const ButtonsContainer = (props: IButtonProps) => {
  const { className, narrow, offer, onCallClick, onChatClick } = props;

  const buttonClassName = narrow ? styles['narrow'] : undefined;
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionButtonExpGroup = useSelector(selectABCActionButtonExpGroup);
  const { phones } = offer;
  const phoneNumber = phones[0];

  // для десктопа
  const [showPhoneNumbers, setShowPhoneNumbers] = React.useState(false);
  const handleCallClick = () => {
    setShowPhoneNumbers(true);
    onCallClick();
  };

  const buttonGroup = getButtonGroupType({
    offer,
    deviceType,
    isDailyrentOnlineBookingEnabled,
  });

  if (isMobile && ['B', 'C'].includes(actionButtonExpGroup || '')) {
    return <ButtonsForAbcExpContainer {...props} />;
  }

  switch (buttonGroup) {
    case EButtonGroupType.CIAN_OFFER_MOBILE: {
      return (
        <div className={cn(styles['root'], className)}>
          <div className={cn(styles['button-container'], buttonClassName)}>
            <LinkButton
              href={`tel:${phoneNumber}`}
              onClick={onCallClick}
              data-actionType={offer.actionType}
              role="button"
              fullWidth
            >
              Позвонить
            </LinkButton>
          </div>
          <div className={cn(styles['button-container'], buttonClassName)}>
            <ChatButton offer={offer} onClick={onChatClick} fullWidth />
          </div>
        </div>
      );
    }
    case EButtonGroupType.CIAN_OFFER_DESKTOP: {
      return (
        <div className={cn(styles['root'], className)}>
          {showPhoneNumbers ? (
            <PhoneNumber phone={phoneNumber} narrow={narrow} />
          ) : (
            <div className={cn(styles['button-container'], buttonClassName)}>
              <CallButton onClick={handleCallClick} phones={phones} actionType={offer.actionType} fullWidth />
            </div>
          )}
          <div className={cn(styles['button-container'], buttonClassName)}>
            <ChatButton offer={offer} onClick={onChatClick} fullWidth />
          </div>
        </div>
      );
    }
    case EButtonGroupType.ONLY_CHAT: {
      return (
        <div className={cn(styles['root'], className)}>
          <div className={cn(styles['button-container'], buttonClassName)}>
            <ChatButton offer={offer} onClick={onChatClick} theme="fill_primary" />
          </div>
        </div>
      );
    }
    case EButtonGroupType.CIAN_OFFER_MOBILE_ONLINE_BOOKING:
    case EButtonGroupType.CIAN_OFFER_DESKTOP_ONLINE_BOOKING:
    case EButtonGroupType.PARTNER_OFFER_MOBILE:
    case EButtonGroupType.PARTNER_OFFER_DESKTOP:
    default: {
      return null;
    }
  }
};
